import { render } from "./Chapter.vue?vue&type=template&id=05955d29&scoped=true"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"

import "./Chapter.vue?vue&type=style&index=0&id=05955d29&scoped=true&lang=css"

import exportComponent from "/Users/hrko/_HACKERSANDDESIGNERS/Code/chatty-latest/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05955d29"]])

export default __exports__